import { Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ContainerIcon } from '../styles';
import { ReactComponent as CopyIcon } from './../../../../assets/copy_icon.svg';
import { useTranslation } from 'react-i18next';

export const CardCopyCode = ({ setShowCopyCode, setShowGtm, showCopyCode }) => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card
      sx={{
        padding: '16px',
        marginBlockStart: '16px',
        backgroundColor: '#fffeFe',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <Row className="mb-3">
        <Column xs={9} style={{ fontSize: '20px', fontWeight: '500' }}>
          {t('cookies:show.copyCode.title')}
        </Column>
        <Column style={{ display: 'flex', justifyContent: 'end' }}>
          <ContainerIcon
            onClick={() => {
              setShowGtm(false);
              setShowCopyCode(!showCopyCode);
            }}
            active={showCopyCode}
          >
            <CopyIcon width="44px" height="44px" style={{ padding: '8px' }} />
          </ContainerIcon>
        </Column>
      </Row>
      <Row className="mb-3">
        <Column xs={12}>
          <p className="mt-0 mb-4">
            {t('cookies:show.copyCode.description')}
          </p>
        </Column>
      </Row>
    </Card>
  );
};
